import { omit } from 'lodash-es';

import { DIALOG_CONTAINER_POSITION } from '../VDialog';
import { BASE_SIZE } from '../constant';

export enum DRAWER_POSITION {
  LEFT = DIALOG_CONTAINER_POSITION.LEFT,
  RIGHT = DIALOG_CONTAINER_POSITION.RIGHT,
  TOP = DIALOG_CONTAINER_POSITION.TOP,
  BOTTOM = DIALOG_CONTAINER_POSITION.BOTTOM,
}

export const DRAWER_SIZE = omit(BASE_SIZE, ['LG', 'SM', 'XL']);
